module.exports = __webpack_public_path__ + "static/arrow-right-88f8b35d845ba9363744f76a0faab14b.png";